export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  function getProfileState(type){

    let url = "/" + type;

    let state = {
      parent: "app",
      url: url,
      feature: "menu.settings.profile",
      views: {
        "main": {
          template: require("./eaProfilePage/eaProfilePageModule.html"),
          controller: "eaProfilePageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {

              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }],
        userHasDemoFeature: ["FeatureService", "$q", (FeatureService, $q) => {
          return $q((resolve)=> {
            FeatureService.hasDemoUserFeature().then(function (hasFeature) {
              resolve(hasFeature);
            });
          });
        }],
        userIsDemoUser: ["AuthenticationService", "$q", (AuthenticationService, $q) => {
          return $q((resolve)=> {
            AuthenticationService.isDemoUser().then(function (isDemo) {
              resolve(isDemo);
            });
          });
        }],
        type: () => {
          return type;
        }
      }
    };

    //console.log(state);
    return state;
  }

  $stateProvider
    .state('profile', getProfileState("profile"))
    .state('settingsProtectBuy', getProfileState("protectBuySettings"))
    .state('settingsProfileOnly', getProfileState("userProfile"))
    .state('settingsChangePassword', getProfileState("changePassword"))
    .state('settingsSecurityQuestion', getProfileState("securitySettings"))
    .state('settingsChangeEmail', getProfileState("changeEmail"))
    .state('settingsPhoneNumbers', getProfileState("phoneNumbers"))
    .state('settingsPortletSettings', getProfileState("portletSettings"))
    .state('profileWithScroll', {
      parent: "app",
      url: "/profile/:scrollTo",
      feature: "menu.settings.profile",
      views: {
        "main": {
          template: require("./eaProfilePage/eaProfilePageModule.html"),
          controller: "eaProfilePageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {

              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }]
      }
    })
    .state("securitySettingsChanged", {
      parent: "app",
      url: "/securitySettingsChanged",
      views: {
        "main": {
          template: require("./components/eaSecurityQuestion/eaSecuritySettingsChanged.tpl.html")
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }]
      }
    });
}];



// WEBPACK FOOTER //
// ./src/ui/modules/eaSettings/eaProfile/routes.js